import React from 'react';
import { Link } from 'react-router-dom';
import { PageLayout } from '../components/layout/PageLayout';
import { useSEO } from '../hooks/useSEO';

export default function Success() {
  useSEO(
    "Paygent Request Received | Merchant Onboarding Next Steps",
    "Your Paygent onboarding request has been received. Secure merchant activation instructions will follow."
  );

  return (
    <PageLayout
      title="Your Paygent onboarding request has been received."
      subtitle="Thanks for getting started with Paygent and Tapn. Our team will send secure onboarding instructions so you can complete merchant activation through the proper NMI/Paygent process."
      badge="REQUEST RECEIVED"
    >
      <div className="max-w-3xl mx-auto">
        <div className="bg-white p-10 md:p-12 rounded-3xl border border-gray-100 shadow-xl shadow-green-900/5">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-check-line text-3xl text-green-600 flex items-center justify-center" />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">Next Steps</h2>
          <p className="text-gray-600 mb-8 text-center">
            Your Paygent Standard plan and Tapn request have been securely recorded.
          </p>

          <div className="space-y-4 mb-10">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm mr-4 mt-0.5">1</div>
              <p className="text-gray-700 text-lg">Check your email for onboarding instructions.</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm mr-4 mt-0.5">2</div>
              <p className="text-gray-700 text-lg">Complete the secure merchant activation steps.</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm mr-4 mt-0.5">3</div>
              <p className="text-gray-700 text-lg">Once approved, you will receive access to your Paygent merchant dashboard.</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm mr-4 mt-0.5">4</div>
              <p className="text-gray-700 text-lg">Tapn / Tap to Pay activation may require additional Apple Pay / Google Pay service approval and terms acceptance.</p>
            </div>
          </div>
          
          <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-center border border-gray-100">
            <p className="text-gray-600 font-medium">If you need help, contact Paygent Support.</p>

            <a href="mailto:support@gopaygent.com" className="text-primary-600 hover:text-primary-700 font-medium mt-2 inline-block">support@gopaygent.com</a>
          </div>

          <div className="text-center">
            <Link 
              to="/"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-gray-900 text-white font-bold rounded-xl hover:bg-black transition-colors"
            >
              Return to Homepage
            </Link>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
